import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {OidcSecurityService} from "angular-auth-oidc-client";

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  isLoading = false;
  errorMessage = '';
  private readonly oidcSecurityService = inject(OidcSecurityService);


    login() {
    this.isLoading = true;
    this.oidcSecurityService.authorize();
    this.isLoading = false
  }

}
